import styled, { css } from 'styled-components';

export const TOP_BAR_HEIGHT = 64;
export const FOOTER_HEIGHT = 96;

const Page = styled.div<{ minWidth?: string; grid?: boolean }>`
  height: calc(100vh - ${TOP_BAR_HEIGHT + FOOTER_HEIGHT}px);
  max-width: 1248px;
  overflow-x: auto;
  display: ${({ grid }) => grid && 'grid'};
  padding-left: 16px;
  padding-right: 16px;
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
  grid-gap: 24px;
  grid-auto-rows: minmax(min-content, max-content);
  ${({ theme }) => theme.responsiveMargins};
  ${({ theme }) => theme.mediaQueries.small} {
    ${({ theme, grid }) => grid && theme.grids.small}
  }
  ${({ theme }) => theme.mediaQueries.medium} {
    ${({ theme, grid }) => grid && theme.grids.medium}
  }
  ${({ theme }) => theme.mediaQueries.large} {
    ${({ theme, grid }) => grid && theme.grids.large}
  }
  ${({ theme }) => theme.mediaQueries.xLarge} {
    ${({ theme, grid }) => grid && theme.grids.xLarge}
  }
`;

export default Page;
